import styled from 'styled-components'

export const AddBowtieModalBody = styled.div`
    .Select-menu {
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--gray-600);
            border-radius: 10px;
        }
    }
`
